<template>
  <div class="left-drawer-panel" :class="classes">
    <div v-if="!noExpander" class="left-drawer-panel__expander" @click="expand">
      <badge v-if="badge !== undefined" color="#888888">
        <span slot="badge">{{ badge }}</span>
        <span><img :src="expander" alt=""></span>
      </badge>
      <img v-else :src="expander" alt="">
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Panel hidden on the left of the screen that can be expanded
 */

import Badge from '@/components/badge.vue';

export default {
  name: 'LeftDrawerPanel',
  components: {
    Badge,
  },
  props: {
    right: Boolean,
    displayed: Boolean,
    noExpander: Boolean,
    expander: {
      type: String,
      default: '/images/expand-left.png',
    },
    noRotation: Boolean,
    badge: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      expanded: this.displayed,
    };
  },
  computed: {
    classes() {
      return {
        hidden: !this.expanded,
        right: this.right,
        'no-rotation': this.noRotation,
      };
    },
  },
  watch: {
    displayed(newVal) {
      this.expanded = newVal;
    },
  },
  methods: {
    expand(e) {
      this.expanded = !this.expanded;
      this.$emit(this.expanded ? 'open' : 'close', e);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

$expander-size: 40px;

.left-drawer-panel {
  width: 25%;
  min-width: 240px;
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: $nav-width;
  transition: transform 0.3s ease-in-out;
  z-index: 10006;

  &.hidden {
    transform: translateX(-100%);
    pointer-events: none;
  }
  &.right {
    left: auto;
    right: 0px;

    &.hidden {
      transform: translateX(100%);
    }
  }
  &.display-no-transition {
    transition: none;
    transform: none;
  }
  > .left-drawer-panel__expander {
    position: absolute;
    right: -$expander-size;
    top: 90px;
    width: $expander-size;
    height: $expander-size;
    background: white;
    color: white;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    box-shadow: 3px 0px 3px #999999;
    cursor: pointer;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    z-index: 10003;
    pointer-events: initial;
  }
  &.right .left-drawer-panel__expander {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
    box-shadow: -3px 0px 3px #999999;
    right: unset;
    left: -$expander-size;
  }
  &.no-rotation .left-drawer-panel__expander img {transform: none!important}
  &.hidden .left-drawer-panel__expander img {transform: rotate(180deg)}
  .left-drawer-panel__expander img {width: 100%; transition: transform 0.2s ease-in;}
  &.right.hidden .left-drawer-panel__expander img {transform: rotate(0deg);}
  &.right .left-drawer-panel__expander img {transform: rotate(180deg);}
  .content {
    background: white;
    box-shadow: 0px 0px 5px #999999;
    padding: 15px;
    padding-top: calc(#{$header-height} + 1rem);
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
  }
  &.right .content {
    margin-right: 0px;
  }
  /* When using filters */
  h1.basic-blue-title, h2.basic-sub-title {
    text-align: left;
  }
  h1.basic-blue-title {
    padding-bottom: 5px;
    padding-top: 0px;
    background: transparent;
  }
  h2.basic-sub-title {
    margin: 5px 0px;
  }
}
@media (max-width: $smartphone-landscape) {
  $sp-expander-size: 25px;
  .left-drawer-panel {
    left: $smartphone-nav-width;

    > .left-drawer-panel__expander {
      top: 60px;
    }
    .content {
      padding-top: 55px;
    }
  }
}
@media (max-width: $smartphone-landscape) and (max-height: $smartphone-landscape) {
  $sp-expander-size: 25px;
  .left-drawer-panel {

    &.right .left-drawer-panel__expander {
      left: -$sp-expander-size;
    }
    > .left-drawer-panel__expander {
      padding: 5px;
      right: -$sp-expander-size;
      width: $sp-expander-size;
      height: $sp-expander-size;
    }
  }
}
</style>
